<script setup lang="ts">
const { isDesktop, isMobile } = useLayout();
</script>

<template>
  <div :class="$style.homeSkeleton">
    <SectionsMenuHorizontalApostatudo v-if="isDesktop" />

    <SectionsSliderApostatudo v-if="isDesktop" />

    <!-- Search bar skeleton (mesmo tamanho do BaseSearchContainer: h-36px) -->
    <div :class="$style.searchSkeleton">
      <BaseCommonSkeleton :class="$style.searchBar" />
    </div>

    <!-- Section skeletons (3 seções) -->
    <div
      v-for="i in 3"
      :key="i"
      :class="$style.section"
    >
      <!-- Header: título + ver mais -->
      <div :class="$style.sectionHeader">
        <BaseCommonSkeleton :class="$style.sectionTitle" />
        <BaseCommonSkeleton :class="$style.sectionButton" />
      </div>

      <!-- Mobile: grid 4 colunas, 2 rows (como TabsApostatudo) -->
      <div
        v-if="isMobile"
        :class="$style.mobileGrid"
      >
        <BaseCommonSkeleton
          v-for="j in 8"
          :key="j"
          :class="$style.mobileCard"
        />
      </div>

      <!-- Desktop: grid horizontal (como CasinoMediaList) -->
      <div
        v-else
        :class="$style.desktopGrid"
      >
        <BaseCommonSkeleton
          v-for="j in 6"
          :key="j"
          :class="$style.desktopCard"
        />
      </div>
    </div>
  </div>
</template>

<style module lang="postcss">
.homeSkeleton {
  @apply pb-2 sm:pb-4 -mt-4 lg:mt-4 xl:mt-[1.4rem];
}

.searchSkeleton {
  @apply mb-4;
}

.searchBar {
  @apply w-full h-[36px] rounded-md;
}

.section {
  @apply mb-4 rounded-lg;
  min-height: 236px;

  @media (min-width: 768px) {
    min-height: 220px;
    margin-bottom: 20px;
  }
}

.sectionHeader {
  @apply flex justify-between items-center pb-1.5 md:pb-2;
}

.sectionTitle {
  @apply h-[20px] max-w-[200px] flex-1;
}

.sectionButton {
  @apply h-[20px] max-w-[60px] flex-1;
}

/* Mobile: imita TabsApostatudo (4 colunas, 2 rows, aspect 6/7) */
.mobileGrid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(2, auto);
  gap: 4px;
}

.mobileCard {
  width: 100%;
  aspect-ratio: 6 / 7;
  border-radius: 4px;
}

/* Desktop: imita CasinoMediaList (row única) */
.desktopGrid {
  @apply grid w-full gap-[8px];

  @media (min-width: 768px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  @media (min-width: 1100px) {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  @media (min-width: 1200px) {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  @media (min-width: 1400px) {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
}

.desktopCard {
  width: 100%;
  height: 160px;
  border-radius: 4px;
}
</style>
